import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs";
import { MessageService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { FeedbackActions } from "./feedback.actions";

@Injectable()
export class FeedbackEffect {
  constructor(
    private actions$: Actions,
    private readonly messageService: MessageService,
    private readonly translate: TranslateService,
  ) {}

  feedbackSuccessActions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FeedbackActions.success),
      tap((param) => {
        this.showSuccess(param.message);
      }),
    );
  }, {dispatch: false, functional: true});


  feedbackFailureActions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FeedbackActions.failure),
      tap((param) => {
        this.showError(param.message);
      }),
    );
  }, {dispatch: false, functional: true});

  feedbackWarningActions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FeedbackActions.warning),
      tap((param) => {
        this.showWarning(param.summary, param.message);
      }),
    );
  }, {dispatch: false, functional: true});


  showSuccess(detail: string) {
    this.messageService.add({
      severity: 'success',
      summary: this.translate.instant('feedback.summary.success'),
      detail: detail
    });
  }

  showError(detail: string) {
    this.messageService.add({
      severity: 'error',
      summary: this.translate.instant('feedback.summary.error'),
      detail: detail,
      life: 2000,
    });
  }

  showWarning(summary: string, detail: string) {
    this.messageService.add({
      severity: 'warn',
      summary: summary,
      detail: detail,
      life: 3000,
    });
  }

}
